document.addEventListener('DOMContentLoaded', () => {
    ProductVariantSelector.init();
    QuantitySelector.init();
    ProductImageGallery.init();
    ContentAccordions.init();
    TextTruncation.init();
});

const ProductVariantSelector = {
    init() {
        const select = document.getElementById('product-select-1');
        const stockEl = document.getElementById('variant-stock');
        const priceEl = document.getElementById('variant-price');
        const featured = document.getElementById('pdp-featured-image');
        if (!select || !stockEl || !priceEl || !featured) return;

        const scriptTag = document.querySelector('script[type="application/json"][id^="ProductJson-"]');
        if (!scriptTag) return;
        const productData = JSON.parse(scriptTag.textContent);

        const updateUI = (arg) => {
            const opt = select.options[select.selectedIndex];
            stockEl.textContent = (opt.dataset.stock || '0') + '+ Left';
            priceEl.textContent = Shopify.formatMoney(opt.dataset.price || 0);

            let variant;
            if (arg && arg.id) {
                variant = arg;
            } else {
                const id = parseInt(select.value, 10);
                variant = productData.variants.find(v => v.id === id);
            }
            if (!variant) return;

            // console.log('variant', variant)

            // Featured image
            if (variant.featured_image && variant.featured_image.src) {
                featured.src = variant.featured_image.src;
                featured.alt = variant.featured_image.alt || '';
                featured.dataset.zoom = variant.featured_image.src;
            }

            if (variant.available) {
                // Selected a valid variant that is available
                // var msgElement = document.getElementById('ProductMessage');
                // msgElement.innerHTML = ''; // clear any messages about unavailable
                var cartButton = document.getElementById('AddToCartButton');
                cartButton.disabled = false; // re-enable button if disabled
                cartButton.classList.remove('disabled');
                cartButton.innerHTML = 'Add To Cart';

            } else {
                // Variant is sold out.
                // update with a message Sold Out
                // var msgElement = document.getElementById('ProductMessage');
                // msgElement.innerHTML = 'This option is currently unavailable.'
                // make the add to cart button disabled
                var cartButton = document.getElementById('AddToCartButton');
                cartButton.disabled = true;
                cartButton.classList.add('disabled');
                cartButton.innerHTML = 'Unavailable';

            }

            // console.log('[VARIANT] Hiding all variant thumbnails');
            document.querySelectorAll('.variant-image').forEach(img => {
                img.style.display = 'none';
            });
            const thumbnails = document.querySelectorAll(`.variant-image[data-variant-id=\"${variant.id}\"]`);
            // console.log(`[VARIANT] Showing ${thumbnails.length} thumbnails for variant ${variant.id}`);
            thumbnails.forEach(img => {
                img.style.display = 'block';
            });

            ProductImageGallery.update();

        };

        updateUI();
        select.addEventListener('change', updateUI);

        this.initShopifyOptionSelectors(updateUI);
    },

    initShopifyOptionSelectors(updateCallback) {
        if (window.Shopify && Shopify.OptionSelectors) {
            Shopify.optionSelectors = Shopify.optionSelectors || {};
            if (!Shopify.optionSelectors['product-select-1']) {
                const productJson = document.querySelector('script[type="application/json"][id^="ProductJson-"]');
                if (!productJson) return;

                Shopify.optionSelectors['product-select-1'] = new Shopify.OptionSelectors('product-select-1', {
                    product: JSON.parse(productJson.textContent),
                    onVariantSelected: updateCallback
                });
            }
        }
    }
};

const QuantitySelector = {
    init() {
        const wrapper = document.querySelector('.quantity-wrapper');
        if (!wrapper) return;

        const input = wrapper.querySelector('input[name="quantity"]');
        const minus = wrapper.querySelector('.minus');
        const plus = wrapper.querySelector('.plus');
        const addBtn = document.getElementById('AddToCartButton');

        if (!input || !minus || !plus) return;

        const form = addBtn ? addBtn.closest('form') : null;

        this.setupQuantityButtons(input, minus, plus);
        this.waitForAppQuantityField(() => {
            this.syncThemeQuantityButtons(input, minus, plus);
        });

        this.setupAddToCartButton(addBtn, form, input, this.updateButtons);
    },

    setupQuantityButtons(input, minus, plus) {
        const updateButtons = () => {
            const val = parseInt(input.value, 10);
            minus.disabled = val <= parseInt(input.min, 10);
            plus.disabled = val >= parseInt(input.max, 10);
        };

        const syncAppQuantity = () => {
            // console.log('[SYNC] Syncing app quantity to', input.value);
            const appQtyEl = document.getElementById('corner-sticy_atc-quantity-value');
            if (appQtyEl) {
                appQtyEl.value = input.value;
                appQtyEl.dispatchEvent(new Event('input', { bubbles: true }));
                appQtyEl.dispatchEvent(new Event('change', { bubbles: true }));
                // console.log('[SYNC] App quantity synced to', appQtyEl.value);
            } else {
                // console.log('[SYNC] App quantity element not found');
            }
        };

        minus.addEventListener('click', () => {
            let val = parseInt(input.value, 10);
            if (val > parseInt(input.min, 10)) {
                input.value = val - 1;
                // console.log('[SYNC] Theme minus clicked, new quantity', input.value);
                updateButtons();
                syncAppQuantity();
            }
        });

        plus.addEventListener('click', () => {
            let val = parseInt(input.value, 10);
            if (val < parseInt(input.max, 10)) {
                input.value = val + 1;
                // console.log('[SYNC] Theme plus clicked, new quantity', input.value);
                updateButtons();
                syncAppQuantity();
            }
        });

        input.addEventListener('input', updateButtons);
        updateButtons();

        this.updateButtons = updateButtons;
    },

    syncThemeQuantityButtons(input, minus, plus) {
        const appQty = document.getElementById('corner-sticy_atc-quantity-value');
        if (!appQty) return;

        const min = parseInt(input.min, 10);
        const max = parseInt(input.max, 10);
        let lastAppValue = appQty.value;

        const updateThemeButtons = () => {
            const val = parseInt(appQty.value || '1', 10);
            minus.disabled = val <= min;
            plus.disabled = val >= max;
        };

        const watch = () => {
            if (appQty.value !== lastAppValue) {
                lastAppValue = appQty.value;
                updateThemeButtons();
            }
            requestAnimationFrame(watch);
        };

        updateThemeButtons(); // sync immediately on init
        requestAnimationFrame(watch);
    },

    waitForAppQuantityField(callback, retries = 30) {
        const el = document.getElementById('corner-sticy_atc-quantity-value');
        if (el) {
            callback();
        } else if (retries > 0) {
            setTimeout(() => {
                this.waitForAppQuantityField(callback, retries - 1);
            }, 200);
        } else {
            console.warn('[SYNC] App quantity field not found after waiting.');
        }
    },



    setupAddToCartButton(addBtn, form, input, updateButtonsCallback) {
        if (!addBtn || !form) return;

        addBtn.addEventListener('click', e => {
            e.preventDefault();
            const formData = new FormData(form);

            fetch('/cart/add.js', {
                method: 'POST',
                body: formData,
                headers: { 'Accept': 'application/json' }
            })
                .then(res => res.json())
                .then(() => {
                    input.value = input.min;
                    updateButtonsCallback();
                })
                .catch(console.error);
        });
    }
};

const ContentAccordions = {
    init() {
        document
            .querySelectorAll('.pdp-top-aside-content-accordian-header')
            .forEach(header => header.addEventListener('click', () => this.toggleAccordion(header)));
    },

    toggleAccordion(header) {
        const drawer = header.nextElementSibling;
        if (!drawer) return;

        const isOpening = !drawer.classList.contains('active');

        const onTransitionEnd = e => {
            if (e.propertyName !== 'height') return;
            if (isOpening) {
                drawer.style.height = 'auto';
            } else {
                drawer.classList.remove('active');
                header.classList.remove('active');
                drawer.style.height = '';
            }
        };

        drawer.addEventListener('transitionend', onTransitionEnd, { once: true });

        if (isOpening) {
            drawer.classList.add('active');
            header.classList.add('active');
            drawer.style.height = '0';
            requestAnimationFrame(() => {
                drawer.style.height = `${drawer.scrollHeight}px`;
            });
        } else {
            drawer.style.height = `${drawer.scrollHeight}px`;
            requestAnimationFrame(() => {
                drawer.style.height = '0';
            });
        }
    }
};

const ProductImageGallery = {
    init() {
        const container = document.querySelector('.pdp-top-aside-thumbs');
        const prevBtn = document.querySelector('.pdp-top-aside-prev');
        const nextBtn = document.querySelector('.pdp-top-aside-next');
        const featuredImg = document.getElementById('pdp-featured-image');
        if (!container || !prevBtn || !nextBtn || !featuredImg) return;

        // grab only the tiles that are actually showing in your grid
        const allTiles = Array.from(container.querySelectorAll('.pdp-top-aside-images-grid-tile'));
        const originalTiles = allTiles.filter(tile => getComputedStyle(tile).display !== 'none');
        const total = originalTiles.length;
        if (total === 0) return;


        if (total <= 1) {
            container.style.display = 'none';
            // return;
        }

        // never loop more than you actually have
        const visibleCount = Math.min(4, total);

        // figure out which tile is your current featured image
        const normalize = url => {
            try { return new URL(url, location.origin).pathname; }
            catch (_) { return url; }
        };
        const featuredPath = normalize(featuredImg.src);
        let start = originalTiles.findIndex(tile => normalize(tile.dataset.featured) === featuredPath);
        if (start < 0) start = 0;

        // stash state on the object
        this.container = container;
        this.originalTiles = originalTiles;
        this.total = total;
        this.visibleCount = visibleCount;
        this.start = start;
        this.prevBtn = prevBtn;
        this.nextBtn = nextBtn;

        // 👉 check arrows on load
        this.updateArrowVisibility();

        // 👉 recheck arrows on resize
        window.addEventListener('resize', () => this.updateArrowVisibility());

        // 👉 render thumbnails
        this.renderThumbnails();

        // initial render
        this.renderThumbnails();

        // wire up buttons to rotate + re-render + update featured
        prevBtn.addEventListener('click', () => {
            this.start = (this.start - 1 + this.total) % this.total;
            this.renderThumbnails();
            this.updateFeatured();
        });
        nextBtn.addEventListener('click', () => {
            this.start = (this.start + 1) % this.total;
            this.renderThumbnails();
            this.updateFeatured();
        });
    },

    updateArrowVisibility() {
        if (!this.prevBtn || !this.nextBtn) return;
        const viewportWidth = window.innerWidth;
        let showArrows = false;
        // if (viewportWidth > 460) {
        //     showArrows = this.total >= 4;
        // } else {
        //     showArrows = this.total >= 3;
        // }
        showArrows = this.total >= 4;

        this.prevBtn.style.display = showArrows ? 'block' : 'none';
        this.nextBtn.style.display = showArrows ? 'block' : 'none';
    },

    renderThumbnails() {
        const { container, originalTiles, visibleCount, total, start } = this;
        // clear out old thumbs
        container.innerHTML = '';
        // remove any leftover .active
        originalTiles.forEach(tile => tile.classList.remove('active'));

        // append just the next `visibleCount` tiles
        for (let i = 0; i < visibleCount; i++) {
            const idx = (start + i) % total;
            const tile = originalTiles[idx];
            // only the first one in this window gets .active
            tile.classList.toggle('active', i === 0);
            container.appendChild(tile);
        }
    },

    updateFeatured() {
        const { originalTiles, start } = this;
        const tile = originalTiles[start];
        const featuredImg = document.getElementById('pdp-featured-image');
        if (!tile || !featuredImg) return;

        const newSrc = tile.dataset.featured;
        const newZoom = tile.dataset.zoom;
        const newAlt = tile.dataset.alt;

        // fade-out → swap → fade-in
        featuredImg.style.opacity = 0;
        featuredImg.addEventListener('transitionend', function onFade(e) {
            if (e.propertyName !== 'opacity') return;
            featuredImg.removeEventListener('transitionend', onFade);
            featuredImg.src = newSrc;
            featuredImg.dataset.zoom = newZoom;
            featuredImg.alt = newAlt;
            requestAnimationFrame(() => {
                featuredImg.style.opacity = 1;
            });
        });
    }
};


ProductImageGallery.update = function () {
    const container = document.querySelector('.pdp-top-aside-thumbs');
    const prevBtn = document.querySelector('.pdp-top-aside-prev');
    const nextBtn = document.querySelector('.pdp-top-aside-next');
    const featuredImg = document.getElementById('pdp-featured-image');

    if (!container || !prevBtn || !nextBtn || !featuredImg) return;

    const productTiles = Array.from(container.querySelectorAll('.product-image'));
    const visibleVariantTiles = Array.from(container.querySelectorAll('.variant-image'))
        .filter(tile => tile.style.display !== 'none');

    const combinedTiles = [...visibleVariantTiles, ...productTiles];
    if (combinedTiles.length === 0) return;

    const normalizeUrl = (url) => {
        try {
            const pathname = new URL(url, window.location.origin).pathname;
            return pathname;
        } catch (e) {
            return url;
        }
    };

    const featuredImgSrc = normalizeUrl(featuredImg.src);
    let activeIdx = -1;

    combinedTiles.forEach((tile, index) => {
        const thumbSrc = normalizeUrl(tile.dataset.featured);
        // console.log('thumbSrc', thumbSrc);
        // console.log('featuredImgSrc', featuredImgSrc);

        if (thumbSrc === featuredImgSrc) {
            activeIdx = index;
        }
    });

    if (activeIdx === -1) {
        activeIdx = 0;
    }

    this.start = activeIdx;
    this.originalTiles = combinedTiles;
    this.total = combinedTiles.length;
    this.visibleCount = 4;
    this.featuredImg = featuredImg;
    this.container = container;

    this.renderThumbnails();
};



ProductImageGallery.renderThumbnails = function () {
    const { container, originalTiles, visibleCount, start } = this;
    if (!container || !originalTiles) return;

    // Hide all thumbnails first
    originalTiles.forEach(tile => {
        tile.classList.remove('active');
        tile.style.display = 'none';
    });

    // Show next `visibleCount` tiles starting from current start
    for (let i = 0; i < visibleCount; i++) {
        const idx = (start + i) % originalTiles.length;
        const tile = originalTiles[idx];

        // ✅ ONLY the tile at `this.start` is active
        tile.classList.toggle('active', idx === start);

        tile.style.display = 'block';
        container.appendChild(tile); // safe to append
    }
};



ProductImageGallery.updateFeatured = function () {
    const { featuredImg, originalTiles, start } = this;
    if (!featuredImg || !originalTiles) return;

    const tile = originalTiles[start];
    const newSrc = tile.dataset.featured;
    const newZoom = tile.dataset.zoom;
    const newAlt = tile.dataset.alt;

    // Skip update if it's the same image
    if (featuredImg.src === newSrc) return;

    // Preload image first
    const img = new Image();
    img.onload = () => {
        featuredImg.style.opacity = 0;

        const onFadeOut = (e) => {
            if (e.propertyName !== 'opacity') return;
            featuredImg.removeEventListener('transitionend', onFadeOut);

            featuredImg.src = newSrc;
            featuredImg.dataset.zoom = newZoom;
            featuredImg.alt = newAlt;

            requestAnimationFrame(() => {
                featuredImg.style.opacity = 1;
            });
        };

        featuredImg.addEventListener('transitionend', onFadeOut);
    };
    img.src = newSrc;
};




const TextTruncation = {
    init() {
        document
            .querySelectorAll('.pdp-top-aside-description-copy')
            .forEach(container => {
                // guard so we only bind each block once
                if (container.dataset.truncInit) return;
                container.dataset.truncInit = '1';

                const p = container.querySelector('p');
                const arrow = container.querySelector('.pdp-top-aside-description-arrow');
                if (!p) return;

                // stash the full copy
                p.dataset.fullText = p.textContent.trim();

                // helper to clamp + show arrow
                const applyClamp = () => {
                    // restore full text before measuring
                    p.textContent = p.dataset.fullText;
                    const wasTruncated = this.clampParagraph(p, 2);
                    if (wasTruncated && arrow) {
                        arrow.style.display = 'inline-block';
                    }
                };

                // 1) run as soon as possible
                requestAnimationFrame(applyClamp);
                // 2) run again in case fonts/layout weren’t ready
                setTimeout(applyClamp, 100);

                // arrow click → toggle expand/collapse
                if (arrow) {
                    arrow.addEventListener('click', () => this.toggle(container, p));
                }

                // ellipsis click → expand if collapsed
                container.addEventListener('click', e => {
                    if (e.target.classList.contains('ellipsis') &&
                        !container.classList.contains('expanded')
                    ) {
                        this.toggle(container, p);
                    }
                });
            });
    },

    toggle(container, p) {
        const isExpanded = container.classList.toggle('expanded');

        if (isExpanded) {
            // EXPAND
            p.textContent = p.dataset.fullText;
            requestAnimationFrame(() => {
                p.style.maxHeight = p.scrollHeight + 'px';
            });
        } else {
            // COLLAPSE
            p.style.maxHeight = p.dataset.collapsedHeight + 'px';
            const onEnd = e => {
                if (e.propertyName === 'max-height') {
                    TextTruncation.clampParagraph(p, 2);
                    p.removeEventListener('transitionend', onEnd);
                }
            };
            p.addEventListener('transitionend', onEnd);
        }
    },

    // your original binary-search clampParagraph
    clampParagraph(p, lines = 2) {
        const style = getComputedStyle(p);
        let lh = parseFloat(style.lineHeight);
        if (isNaN(lh)) lh = parseFloat(style.fontSize) * 1.2;

        const pad = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
        const collapsed = lh * lines + pad;
        const full = p.dataset.fullText;

        // store collapsed height
        p.dataset.collapsedHeight = collapsed;

        // reset to full to measure
        p.textContent = full;
        if (p.scrollHeight <= collapsed) return false;

        // binary search
        let lo = 0, hi = full.length, mid;
        while (lo < hi) {
            mid = Math.ceil((lo + hi) / 2);
            p.textContent = full.slice(0, mid) + '…';
            if (p.scrollHeight > collapsed) hi = mid - 1;
            else lo = mid;
        }

        // finish trim
        const trimmed = full.slice(0, lo).replace(/\s+\S*$/, '');
        p.innerHTML = `${trimmed}<span class="ellipsis">…</span>`;
        p.style.overflow = 'hidden';
        p.style.maxHeight = collapsed + 'px';

        return true;
    }
};

// run on initial load + once more when all resources finish loading
//   document.addEventListener('DOMContentLoaded', () => TextTruncation.init());
window.addEventListener('load', () => TextTruncation.init());
